const VARIANTS = String.raw`(?:[\w[\]&>=/-]+:)*`;
const SIZE_OR_PLACEMENT = String.raw`(?:w|min-w|max-w|flex|basis|grow|shrink|self|justify-self|col|row|order)(?:-|$)`;
const MARGIN = String.raw`-?m[trblxy]?-(?:\d|auto|px|\[)`;
// eslint-disable-next-line security/detect-non-literal-regexp -- built once from the constant fragments above, no user input
const LAYOUT_CLASS = new RegExp(`^${VARIANTS}(?:${SIZE_OR_PLACEMENT}|${MARGIN})`);

/** Splits an input's classes into those that place it in its parent (for a wrapper) and those that style the field itself. */
export function splitInputLayoutClasses(className: string | undefined) {
  const layout: string[] = [];
  const field: string[] = [];
  for (const token of (className ?? '').split(/\s+/).filter(Boolean)) {
    (LAYOUT_CLASS.test(token) ? layout : field).push(token);
  }
  return { layout: layout.join(' '), field: field.join(' ') };
}
